<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
    <path
      d="M12 10H20C21.108 10 22 10.892 22 12V20C22 21.108 21.108 22 20 22H12C10.892 22 10 21.108 10 20V12C10 10.892 10.892 10 12 10Z"
      fill="currentColor"
    />
  </svg>
</template>
